import {NavLink} from 'react-router-dom';
import styled from 'styled-components';

import {colors, breakpoint} from 'theme';

export const SidebarMenu = styled.nav`
    display: flex;
    flex-flow: column wrap;
    gap: 10px;

    a {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;

        text-decoration: none;
    }
`;

export const MenuItem = styled(NavLink)`
    padding: 20px;
    font-size: 18px;
    color: #1d2229;
    border-radius: 6px;
    transition: background 0.15s ease-in-out;

    &:hover {
        background: ${colors.brandLight};
    }

    &.active {
        background-color: ${colors.brandPrimary};
        color: ${colors.white};

        svg {
            color: ${colors.white};
        }
    }

    @media (min-width: ${breakpoint.tablet}) {
        padding: 12px;
        font-size: 14px;
        max-width: 200px;
    }
`;

export const MenuIcon = styled.div`
    margin-left: 8px;
    margin-right: 16px;
`;

export const MenuItemTitle = styled.span`
    font-weight: 600;
    line-height: 1rem;
`;
